import Image from 'next/image';
import { StyledDraggableOption } from './DraggableOption.styled';
import { useDraggable } from '@dnd-kit/core';

export default function DraggableOption({ option, answered, disabled }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: `option-${option.id}`,
      disabled,
      data: { option },
    });

  return (
    <StyledDraggableOption
      className={`option ${answered ? 'answered' : ''} ${
        disabled ? 'disabled' : ''
      } ${isDragging ? 'dragging' : ''}`}
      ref={setNodeRef}
      style={
        transform
          ? {
              transform: `translate(${transform.x}px, ${transform.y}px)`,
            }
          : {}
      }
      {...listeners}
      {...attributes}
    >
      <Image
        src={option.image}
        alt={`Option ${option.id}`}
        width={1280}
        height={720}
        layout="responsive"
        objectFit="contain"
      />
    </StyledDraggableOption>
  );
}
